// const
const radioDimention = '22px';

// config
export const twComponents = ({ theme, addComponents }) => {
  const components = {
    // skeleton loading
    '.loader': {
      background: '#f3f3f3',
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '0',
        left: '-100%',
        width: '100%',
        height: '100%',
        background: 'linear-gradient(to right, #f3f3f3, #e0e0e0, #f3f3f3)',
        animation: 'loading 1.5s linear infinite',
      },
    },
    // basic input
    '.form-input': {
      height: '38px',
      padding: '8px 4px',
      '@apply border': '',
      '@apply border-gray-400': '',
      '@apply rounded-md': '',
      // '@apply font-main': '',
      // '@apply text-med': '',
      // '@apply text-input': '',
      '@apply outline-none': '',
      transition: 'border .2s linear',
      '&:focus': {
        // '@apply border-terceary': '',
      },
      '&:disabled': {
        opacity: '1',
        background: 'light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3))',
        // '@apply bg-disabled/30': ''
      },
      '&[type="number"]': {
        '&::-webkit-outer-spin-button': {
          '@apply appearance-none': '',
          '@apply m-0': '',
        },
        '&::-webkit-inner-spin-button': {
          '@apply appearance-none': '',
          '@apply m-0': '',
        },
      },
      '&[type="search"]': {
        '&::-webkit-search-cancel-button': {
          '@apply appearance-none': '',
        },
      },
    },
    // input radio
    '.form-radio': {
      height: radioDimention,
      width: radioDimention,
      aspectRatio: '1',
      padding: '3px',
      background: `radial-gradient(farthest-side, ${theme(
        'colors.primary'
      )} 94%, #0000) 50%/0 0 no-repeat content-box`,
      borderRadius: '50%',
      border: `calc(${radioDimention}/8) solid`,
      '@apply border-primary': '',
      outlineOffset: `calc(${radioDimention}/10)`,
      cursor: 'pointer',
      fontSize: 'inherit',
      '@apply appearance-none': '',
      transition: '.3s',
      '&:checked': {
        '@apply border-primary': '',
        backgroundSize: '100% 100%',
      },
      '&:disabled': {
        // '@apply border-disabled/30':'',
        '@apply cursor-not-allowed': '',
        '& + p': {
          // '@apply text-disabled': '',
          '@apply cursor-not-allowed': '',
        },
      },
    },
    // input checkbox
    '.form-checkbox': {
      '@apply h-5': '',
      '@apply w-5': '',
      '@apply appearance-none': '',
      '@apply bg-white': '',
      '@apply rounded': '',
      '@apply border-2': '',
      '@apply border-black': '',
      '@apply cursor-pointer': '',
      '@apply relative': '',
      transition: '.3s',
      '&:disabled': {
        '@apply cursor-not-allowed': '',
        '@apply border-gray-300': '',
        '& + p': {
          '@apply text-gray-300': '',
          '@apply cursor-not-allowed': '',
        },
      },
      '&:checked': {
        '@apply bg-primary': '',
        '&:disabled': {
          '@apply bg-gray-300': '',
        },
        '&::after': {
          content: '"✓"',
          color: 'white',
          position: 'absolute',
          top: '-4px',
          right: '3px',
        },
      },
    },
    // input switch
    '.form-switch': {
      '@apply w-[36px]': '',
      '@apply h-[20px]': '',
      '@apply flex': '',
      '@apply items-center': '',
      '@apply justify-start': '',
      '@apply rounded-xl': '',
      '@apply p-[2px]': '',
    },

    '.card': {
      '@apply px-4': '',
      '@apply py-[4px]': '',
      '@apply rounded-[10px]': '',
    },
    '.theme-scrollbar': {
      '&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: `${theme('colors.primaryDark')}`,
        borderRadius: '2px',
        '&:hover': {
          backgroundColor: '#555',
        },
      },
      // Para Firefox
      // 'scrollbar-width': 'thin',
      // 'scrollbar-color': {
      //   "@apply bg-primaryDark":''
      // },
    },
  };
  addComponents(components);
};
